import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/logo-11739509362.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "btn_wrap" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"margin-right":"5px"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { style: {"margin-right":"5px"} }
const _hoisted_8 = { class: "pc_nav dis_tablet_desktop" }
const _hoisted_9 = {
  id: "pm_pc_nav_02",
  class: "pm-navigation_horizon_pc_nav_02"
}
const _hoisted_10 = { class: "dep1" }
const _hoisted_11 = {
  href: "javascript:alert('전화연결은 스마트폰에서만 가능합니다.');",
  class: "icon-phone m_tel dis_mobile"
}
const _hoisted_12 = {
  id: "pm_mo_nav_01",
  class: "pm-navigation_vertical_toggle_mo_nav_01"
}
const _hoisted_13 = { class: "dep1" }
const _hoisted_14 = { class: "dep2" }
const _hoisted_15 = { class: "dep2" }
const _hoisted_16 = { class: "dep2" }
const _hoisted_17 = { class: "dep2" }
const _hoisted_18 = { class: "dep2" }

import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { NDropdown, NIcon } from "naive-ui";
import { Call, Menu } from "@vicons/ionicons5";
import * as common from "@/assets/common/common"; // common.ts 파일이 있다면
import { useAuth } from "@/composables/useAuth";
import { firebaseAuth, getCallable } from "@/config/env";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserNavbar',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const menuClicked = ref(false);
const nDropOprionProps = {
  style: {
    color: "#fff",
  },
};
const createXOpt = ref([
  {
    label: "CreateX 소개",
    key: USER_ROUTES.Intro.Path,
    props: nDropOprionProps,
  },
]);
const surveyOpt = ref([
  {
    label: "PUTT2.0 다중재능검사",
    key: USER_ROUTES.Product.Testing.Putt.Path,
    props: nDropOprionProps,
  },
  {
    label: "TOCC창의역량검사",
    key: USER_ROUTES.Product.Testing.Tocc.Path,
    props: nDropOprionProps,
  },
  {
    label: "KAT지식통각검사",
    key: USER_ROUTES.Product.Testing.Kat.Path,
    props: nDropOprionProps,
  },
]);
const coachOpt = ref([
  {
    label: "PUTT2.0_학습진로상담코칭",
    key: USER_ROUTES.Product.Coaching.Putt.Path,
    props: nDropOprionProps,
  },
  {
    label: "TOCC_학습진로상담코칭",
    key: USER_ROUTES.Product.Coaching.Tocc.Path,
    props: nDropOprionProps,
  },
]);
const activityOpt = ref([
  {
    label: "재능진로전공직업 탐색 프로젝트",
    key: USER_ROUTES.Product.Activity.Talent.Path,
    props: nDropOprionProps,
  },
  {
    label: "꿈 창업 프로젝트",
    key: USER_ROUTES.Product.Activity.Startup.Path,
    props: nDropOprionProps,
  },
  {
    label: "데이터 사이언스 체험 활동",
    key: USER_ROUTES.Product.Activity.Career.Path,
    props: nDropOprionProps,
  },
  {
    label: "성장–폴리오 과정",
    key: USER_ROUTES.Product.Activity.Growth.Path,
    props: nDropOprionProps,
  },
]);
const eduOpt = ref([
  {
    label: "전문가 과정",
    key: USER_ROUTES.Product.Expert.Expert.Path,
    props: nDropOprionProps,
  },
  {
    label: "자격증 관리",
    key: USER_ROUTES.Product.Expert.Cert.Path,
    props: nDropOprionProps,
  },
]);

const isScrolled = ref(false);
const activeIndex = ref<number | null>(null);

watch(route, () => {
  inactivateMenu();
});

function handleSelect(key: string) {
  router.push(`${key}`);
}

function handleScroll() {
  isScrolled.value = window.scrollY > 0;
}

function toggleMenuBtn() {
  menuClicked.value = !menuClicked.value;
  activeIndex.value = null;
}

function toggleMenu(idx: number) {
  if (idx === activeIndex.value) {
    activeIndex.value = null;
  } else {
    activeIndex.value = idx;
  }
}

function inactivateMenu() {
  menuClicked.value = false;
  activeIndex.value = null;
}

const {
  loading,
  isLoggedIn,
  loggedInUserId,
  handleLogout,
  isOrgUser,
  isOrgAdmin,
} = useAuth();

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "fixed_header",
      class: _normalizeClass(['logo_wrap_01', { on: isScrolled.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: `${_unref(USER_ROUTES).Join.Path}`,
                    alt: "개인·회원가입"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("개인·회원가입")
                    ])),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: `${_unref(USER_ROUTES).RequestOrgRegist.Path}`,
                    alt: "기관·신규등록신청"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("기관·신규등록신청")
                    ])),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleLogout) && _unref(handleLogout)(...args)), ["prevent"]))
                  }, "로그아웃")
                ]),
                _createElementVNode("li", null, [
                  (_unref(isOrgUser) || _unref(isOrgAdmin))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `${_unref(USER_ROUTES).Mypage.Order.Org.Path}`,
                        alt: "마이페이지"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("마이페이지")
                        ])),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: `${_unref(USER_ROUTES).Mypage.Order.Personal.Path}`,
                        alt: "마이페이지"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("마이페이지")
                        ])),
                        _: 1
                      }, 8, ["to"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("h1", null, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Home.Path}`
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_0,
                style: {"vertical-align":"middle","border":"0"},
                alt: "",
                title: ""
              }, null, -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ on: _ctx.$route.path.includes(_unref(USER_ROUTES).Intro.Path) })
              }, [
                _createVNode(_unref(NDropdown), {
                  trigger: "hover",
                  placement: "bottom-start",
                  options: createXOpt.value,
                  onSelect: handleSelect,
                  class: "custom-dropdown-style"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Intro.Path}`
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("CreateX소개 ")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["options"])
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({
                  on:
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Testing.Putt.Path
                    ) ||
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Testing.Tocc.Path
                    ) ||
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Product.Testing.Kat.Path),
                })
              }, [
                _createVNode(_unref(NDropdown), {
                  trigger: "hover",
                  placement: "bottom-start",
                  options: surveyOpt.value,
                  onSelect: handleSelect,
                  class: "custom-dropdown-style"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Product.Testing.Putt.Path}`
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("진단검사 ")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["options"])
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({
                  on:
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Coaching.Putt.Path
                    ) ||
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Coaching.Tocc.Path
                    ),
                })
              }, [
                _createVNode(_unref(NDropdown), {
                  trigger: "hover",
                  placement: "bottom-start",
                  options: coachOpt.value,
                  onSelect: handleSelect,
                  class: "custom-dropdown-style"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Product.Coaching.Putt.Path}`
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("상담코칭 ")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["options"])
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({
                  on:
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Activity.Talent.Path
                    ) ||
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Activity.Startup.Path
                    ) ||
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Activity.Career.Path
                    ) ||
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Activity.Growth.Path
                    ),
                })
              }, [
                _createVNode(_unref(NDropdown), {
                  trigger: "hover",
                  placement: "bottom-start",
                  options: activityOpt.value,
                  onSelect: handleSelect,
                  class: "custom-dropdown-style"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Activity ")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["options"])
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({
                  on:
                    _ctx.$route.path.includes(
                      _unref(USER_ROUTES).Product.Expert.Expert.Path
                    ) ||
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Product.Expert.Cert.Path),
                })
              }, [
                _createVNode(_unref(NDropdown), {
                  trigger: "hover",
                  placement: "bottom-start",
                  options: eduOpt.value,
                  onSelect: handleSelect,
                  class: "custom-dropdown-style"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("전문가교육 ")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["options"])
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  on:
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Price.Org.Path) ||
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Price.Org.Test.Path) ||
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Price.Org.Activity.Path) ||
                    _ctx.$route.path.includes(_unref(USER_ROUTES).Price.Org.Expert.Path),
                })
              }, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Price.Org.Path}`
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("기관신청 ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("a", {
          onClick: toggleMenuBtn,
          class: _normalizeClass(["icon-menu toggleGnb dis_mobile", ['icon-menu toggleGnb dis_mobile', { on: menuClicked.value }]]),
          alt: "모바일 메뉴버튼"
        }, [
          _createVNode(_unref(NIcon), null, {
            default: _withCtx(() => [
              _createVNode(_unref(Menu))
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("a", _hoisted_11, [
          _createVNode(_unref(NIcon), { style: {"transform":"rotateY(3.142rad)"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(Call))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          id: "mo_nav",
          class: _normalizeClass(['mo_nav dis_mobile', { on: menuClicked.value }])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ active: activeIndex.value === 0 })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleMenu(0)))
                }, " CreateX소개 "),
                _createElementVNode("div", {
                  class: _normalizeClass(['menuContent', { contentActive: activeIndex.value === 0 }])
                }, [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Intro.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode(" CreateX 소개 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ], 2)
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ active: activeIndex.value === 1 })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleMenu(1)))
                }, " 진단검사 "),
                _createElementVNode("div", {
                  class: _normalizeClass(['menuContent', { contentActive: activeIndex.value === 1 }])
                }, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Testing.Putt.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode(" PUTT2.0 다중재능검사 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Coaching.Tocc.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" TOCC창의역량검사 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Testing.Kat.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode(" KAT지식통각검사 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ], 2)
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ active: activeIndex.value === 2 })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleMenu(2)))
                }, " 상담코칭 "),
                _createElementVNode("div", {
                  class: _normalizeClass(['menuContent', { contentActive: activeIndex.value === 2 }])
                }, [
                  _createElementVNode("ul", _hoisted_16, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Coaching.Putt.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode(" PUTT2.0_학습진로상담코칭 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Coaching.Tocc.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode(" TOCC_학습진로상담코칭 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ], 2)
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ active: activeIndex.value === 3 })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleMenu(3)))
                }, " Activity "),
                _createElementVNode("div", {
                  class: _normalizeClass(['menuContent', { contentActive: activeIndex.value === 3 }])
                }, [
                  _createElementVNode("ul", _hoisted_17, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" 재능진로전공직업 탐색 프로젝트 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Activity.Startup.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode(" 꿈 창업 프로젝트 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Activity.Career.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode(" 데이터 사이언스 체험 활동 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Activity.Growth.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode(" 성장–폴리오 과정 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ], 2)
              ], 2),
              _createElementVNode("li", {
                role: "toggle",
                class: _normalizeClass({ active: activeIndex.value === 4 })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleMenu(4)))
                }, " 전문가교육 "),
                _createElementVNode("div", {
                  class: _normalizeClass(['menuContent', { contentActive: activeIndex.value === 4 }])
                }, [
                  _createElementVNode("ul", _hoisted_18, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode(" 전문가 과정 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: `${_unref(USER_ROUTES).Product.Expert.Cert.Path}`,
                        onClick: inactivateMenu
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode(" 자격증 관리 ")
                        ])),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ], 2)
              ], 2),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Price.Org.Path}`,
                  onClick: inactivateMenu
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode(" 기관신청 ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ], 2)
      ])
    ], 2)
  ]))
}
}

})